import { ReactComponent as LoadingIcon } from '../../../svgIcons/loading-icon.svg';

import useStyles from './styles';

function Loader() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <LoadingIcon className={classes.loadingIcon} />
    </div>
  );
}
export default Loader;
